/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { AttachmentVO } from '@well/attachment/domain';

export class ProofOfHandoverVO extends JSONable {

  uuid: string | null = null;

  achievedAt: string | null = null;

  comment: string | null = null;

  warehouseEmployeeUuid: string | null = null;

  warehouseEmployeeName: string | null = null;

  driverEmployeeUuid: string | null = null;

  driverEmployeeName: string | null = null;

  executedByEmployeeName: string | null = null;

  attachmentVOs: AttachmentVO[] = [];
}
